<template>
    <b-container class="tz-login">
          <div>
        <b-navbar toggleable="lg" type="dark" variant="info" class="tz-index-nav" >
            <b-navbar-brand href="/">
            <b-img  fluid class="tz-logo" src="/static/image/logo_white.png"/>
            <b-img fluid class="tz-logo-name d-none d-sm-inline" src="/static/image/logo_name.png"  />
            </b-navbar-brand>           
        </b-navbar>
    </div>
            <div class="tz-login-bg tz-login-container">
                
                <div class="tz-login-box">
                        <div>用户登录</div>
                        <div class="tz-err-msg">{{ msg }}</div>
                        <b-form>
                            <b-input v-model="user.username" placeholder="学号" class="tz-input" />
                            <b-input v-model="user.password" type="password" class="tz-input"  placeholder="密码"/>
                        </b-form>
                        <b-button class="tz-login-button" @click="login">登录</b-button>
                </div>
            </div>
    </b-container>
</template>
<script>
import * as userApi from '@/api/member'
import * as auth from '@/utils/auth'
export default {
    data(){
        return {
            user: {
                username:'',
                password:''
            },
            msg: ''
        }
    },
    methods:{
        login(){
           
            if(this.user.username.length == 0){
                this.msg = "用户名不能为空"
                return
            }
            if(this.user.password.length == 0){
                this.msg = "密码不能为空"
                return
            }
            userApi.login(this.user).then(res=> {
                console.log(res)
                if(res.code == 200){
                   auth.setInfo(res.data)
                    this.$router.back()
                }else{
                    this.msg = res.msg
                }
                
            })
        }
    }
}
</script>
<style scoped>

#app{
    height: 100%;
}
.tz-login{
    margin: 0;
    padding: 0;
    height: 100vh;
    max-width: unset;
}
.tz-login-bg{
    background-image: url('/static/image/login_bg.jpg');
    background-size: cover;
}
.tz-login-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.tz-login-box{
    box-shadow: 0 0 0 5px #7dbffb;
    border: 2px solid #16459d;
    /* position: absolute; */
    width: 30rem;
    padding: 1rem;
    background-color: white;
    margin-right: 3rem;
    line-height: 4;
}
.tz-login-button{
    background-color: #0180df;
    color: #d0fcff;
    width: 15rem;
    margin-top: 2rem;
}
.tz-input{
    margin-top: 1rem;
}

.tz-err-msg{
    color: red;
}
.tz-index-nav {
  background: rgba(0,0,0,.5) !important;
  position: absolute;
  width: 100%;
  max-width: 1920px;
  padding:0;
  /* padding-left: 20%;
  padding-right: 20%; */
}
.tz-logo{
  width: 2rem;
  height: 2rem;
  margin-left: 1.5rem;
  /* margin-top: -5px; */
}
.tz-logo-name{
  width: 7rem;
  height: auto;
}
.ml-auto {
  margin-left: auto!important;
}
</style>


// WEBPACK FOOTER //
// src/views/login/index.vue